import React, { useRef } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import { Container, InputGroup, Form } from 'react-bootstrap';
import Testimonials from './Testimonials';
import { useState } from 'react';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';

// Renamed component to match the filename. 
// Destructure the onStepComplete prop directly:
const RegisterProfile = ({ complete }) => {
  const emailRef = useRef();

  const passwordRef = useRef();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');


  // This function is called when the form is submitted
  const handleButtonClick = (e) => {
    e.preventDefault();
    complete(email,  password);
  };

  return (
    <div>
      <Container className="bg-white shadow-lg rounded p-4 my-12 justify-content-center text-center max-w-lg" fluid>
       

        <Form onSubmit={handleButtonClick} autoComplete="off">
          <h1 className="font-bold mb-1 text-instagram">Set up your account</h1>
          <small className="text-muted mb-3 d-block">
            Register using your email and password to access the dashboard.
          </small>

         

          {/* Email */}
          <InputGroup className="mb-3" size="md">
            <InputGroup.Text id="instagram-addon" className="py-3">
              <i className="fa-solid fa-envelope" />
            </InputGroup.Text>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              aria-label="Email"
              aria-describedby="email-addon"
              autoComplete="off"
            />
          </InputGroup>

		  <InputGroup className="mb-3" size="md">
            <InputGroup.Text id="instagram-addon" className="py-3">
              <i className="fa-solid fa-lock" />
            </InputGroup.Text>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              aria-label="Password"
              aria-describedby="password-addon"
              autoComplete="new-password"
            />
          </InputGroup>

          <Button variant="primary" type="submit" className="w-full bg-instagram">
            Continue
          </Button>
		  <br></br> <br></br>
		  <center>
		  <GoogleOAuthProvider clientId="255966676242-fhjo5pkp2eo7argo8oghm2u5u16253uk.apps.googleusercontent.com" data-text="signup_with">
				<GoogleLogin
					onSuccess={complete}
					data-text="signup_with"
					text="signup_with"
				/>
			</GoogleOAuthProvider>
			</center>
        </Form>

        <small className="d-block text-muted mt-6">
          Already have an account?{" "}
          <a className="text-primary" href="/login">
            Login here
          </a>
        </small>
      </Container>
	  <Testimonials/>
    </div>
  );
};

export default RegisterProfile;
